import Store from "App/Store.js";
import TelemetryService from "Telemetry/TelemetryService.js";
import dNoticesHopsClearOrg from "./dNoticesHopsClearOrg.js";

export default (org, uri=null) => {
	dNoticesHopsClearOrg();
	Store.dispatch({type: "org", org, uri});
	TelemetryService.report("dOrg", {Org: org});
};
